<template>
  <div :class="$style.container">
    <div
      :class="$style.containerItem"
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
    >
      <img v-if="item.iconColor" :src="getMarkerIcon(item.iconColor)" />
      <img v-else :src="getPositionIcon()" />
      <div v-html="item.label" />
    </div>
  </div>
</template>

<script>
import { getMarkerIcon, getPositionIcon } from "../Map/helpers";

export default {
  name: "MapLegend",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      getMarkerIcon,
      getPositionIcon
    };
  }
};
</script>

<style module lang="scss">
@import "./MapLegend.scss";
</style>
